import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { shouldShowPromoCodeMessage } from '../utils/helpers';
import JsonAnimation from './JsonAnimation';
import checkAnimation from '../assets/animations/check.json';

import './checkoutOrderComplete.scss';

const pricingLink = source => {
  if (source === 'up-peacock') return '/peacock-upshow';

  return '/';
};

function CheckoutPricingOrderComplete({ source }) {
  const history = useHistory();

  const showPromoCode = source && shouldShowPromoCodeMessage();

  return (
    <div className="main_box flex flex-column align-items-center justify-content-center" id="orderComplete">
      <div className="success">
        <JsonAnimation jsonFile={checkAnimation} style={{ width: '100%', height: '200px' }} />
        <h1>Order Complete !</h1>
      </div>
      <div className="paraf">
        <div className="flex flex-column align-items-start mb-6">
          <h3 className="mb-4">What&apos;s Happening Now ?</h3>
          <p>
            The UPshow team has received the order and will begin the process of building your account and syncing the account to
            your devices to create and easy installation process.
          </p>
        </div>
        <div className="flex flex-column align-items-start mb-6">
          <h3 className="mb-4">What Should I do Next ?</h3>
          <p>
            Soon you&apos;ll receive an email with timeline, next steps and more. If you don&apos;t receive an email, please
            contact <span className="highlight">support@upshow.tv.</span>
          </p>
        </div>
        {showPromoCode && (
          <div className="flex flex-column align-items-start">
            <h3 className="mb-4">Concerned your device won&apos;t arrive on time? </h3>
            <p>
              Shortly, you&apos;ll be provided with a back-up way to get the games using a Peacock insta-watch code so you
              don&apos;t miss a second of the action!
            </p>
          </div>
        )}
      </div>
      <div className="buttons flex">
        <Button className="back_btn" onClick={() => history.push(pricingLink(source))} label="Back to Pricing" />
        <Button onClick={() => history.push(source ? '/peacock-checkout' : '/homepricing')} label="Add Another Location" />
      </div>
    </div>
  );
}

CheckoutPricingOrderComplete.propTypes = {
  source: PropTypes.string,
};

CheckoutPricingOrderComplete.defaultProps = {
  source: undefined,
};

export default CheckoutPricingOrderComplete;
